(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("prop-types"), require("classnames"), require("lodash"), require("react-transition-group/CSSTransition"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define("flood-ui-kit", ["react", "prop-types", "classnames", "lodash", "react-transition-group/CSSTransition", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["flood-ui-kit"] = factory(require("react"), require("prop-types"), require("classnames"), require("lodash"), require("react-transition-group/CSSTransition"), require("react-dom"));
	else
		root["flood-ui-kit"] = factory(root["react"], root["prop-types"], root["classnames"], root["lodash"], root["react-transition-group/CSSTransition"], root["react-dom"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_15__, __WEBPACK_EXTERNAL_MODULE_16__, __WEBPACK_EXTERNAL_MODULE_38__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 39);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var FormRowItem = function (_Component) {
  _inherits(FormRowItem, _Component);

  function FormRowItem() {
    _classCallCheck(this, FormRowItem);

    return _possibleConstructorReturn(this, (FormRowItem.__proto__ || Object.getPrototypeOf(FormRowItem)).apply(this, arguments));
  }

  _createClass(FormRowItem, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var classes = __WEBPACK_IMPORTED_MODULE_0_classnames___default()('form__row__item', this.props.className, (_classnames = {}, _defineProperty(_classnames, 'form__row__item--' + this.props.width, this.props.width), _defineProperty(_classnames, 'form__row__item--grow', this.props.grow), _defineProperty(_classnames, 'form__row__item--shrink', this.props.shrink), _defineProperty(_classnames, 'form__row__item--error', this.props.type === 'error'), _classnames));

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: classes },
        this.props.children
      );
    }
  }]);

  return FormRowItem;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

FormRowItem.propTypes = {
  grow: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  shrink: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['auto', 'one-eighth', 'one-quarter', 'three-eighths', 'one-half', 'five-eighths', 'three-quarters', 'seven-eighths'])
};
FormRowItem.defaultProps = {
  grow: true,
  shrink: true,
  width: 'auto'
};


/* harmony default export */ __webpack_exports__["a"] = (FormRowItem);

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var FormElementAddon = function (_Component) {
  _inherits(FormElementAddon, _Component);

  function FormElementAddon() {
    _classCallCheck(this, FormElementAddon);

    return _possibleConstructorReturn(this, (FormElementAddon.__proto__ || Object.getPrototypeOf(FormElementAddon)).apply(this, arguments));
  }

  _createClass(FormElementAddon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var classes = __WEBPACK_IMPORTED_MODULE_0_classnames___default()('form__element__addon', (_classnames = {}, _defineProperty(_classnames, 'form__element__addon--placed-' + this.props.addonPlacement, this.props.addonPlacement), _defineProperty(_classnames, 'form__element__addon--index-' + this.props.addonIndex, this.props.addonIndex), _defineProperty(_classnames, 'form__element__addon--is-interactive', this.props.isInteractive || this.props.onClick), _defineProperty(_classnames, 'form__element__addon--is-icon', this.props.type === 'icon'), _classnames), this.props.className);

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: classes, onClick: this.props.onClick },
        this.props.children
      );
    }
  }]);

  return FormElementAddon;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

FormElementAddon.propTypes = {
  addonPlacement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['before', 'after']),
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['icon']),
  isInteractive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
FormElementAddon.defaultProps = {
  type: 'icon',
  isInteractive: false
};
/* harmony default export */ __webpack_exports__["a"] = (FormElementAddon);

/***/ }),
/* 5 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_forms__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FormRowItem__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var ToggleInput = function (_Component) {
  _inherits(ToggleInput, _Component);

  function ToggleInput(props) {
    _classCallCheck(this, ToggleInput);

    var _this = _possibleConstructorReturn(this, (ToggleInput.__proto__ || Object.getPrototypeOf(ToggleInput)).call(this, props));

    _this.inputRef = null;
    _this.state = { isActive: false };

    _this.handleInputChange = function (event) {
      return event.stopPropagation();
    };

    _this.handleKeyDown = function (event) {
      if (event.key === ' ' || event.key === 'Enter') {
        event.preventDefault();
        if (!_this.state.isActive) {
          _this.setState({ isActive: !_this.state.isActive });
        }
      }
    };

    _this.handleKeyUp = function (event) {
      if (event.key === ' ' || event.key === 'Enter') {
        _this.inputRef.checked = !_this.inputRef.checked;
        // We're faking the event's target to make it easier to handle this keyboard event.
        _this.triggerChangeEvent({ event: event, target: _this.inputRef });
      }

      if (_this.state.isActive) {
        _this.setState({ isActive: false });
      }
    };

    _this.handleLabelBlur = function (event) {
      if (_this.state.isActive) {
        _this.setState({ isActive: false });
      }

      global.removeEventListener('keydown', _this.handleKeyDown);
      global.removeEventListener('keyup', _this.handleKeyUp);
    };

    _this.handleLabelFocus = function (event) {
      global.addEventListener('keydown', _this.handleKeyDown);
      global.addEventListener('keyup', _this.handleKeyUp);
    };

    _this.setInputRef = function (ref) {
      return _this.inputRef = ref;
    };

    _this.triggerChangeEvent = function (event) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_forms__["a" /* dispatchChangeEvent */])(_this.inputRef);
      _this.props.onChange(event);
    };

    _this.initialValue = props.checked;
    return _this;
  }

  _createClass(ToggleInput, [{
    key: 'getCheckedProp',
    value: function getCheckedProp() {
      // When element is controlled, we provide the checked prop.
      if (this.props.useProps) {
        return this.props.checked != null && this.props.checked;
      }
    }
  }, {
    key: 'getDefaultCheckedProp',
    value: function getDefaultCheckedProp() {
      // When element is uncontrolled, we provide the defaultChecked prop.
      if (!this.props.useProps) {
        return this.props.checked;
      }
    }
  }, {
    key: 'getValueProp',
    value: function getValueProp() {
      if (this.props.type === 'radio') {
        return this.props.value;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var classes = __WEBPACK_IMPORTED_MODULE_0_classnames___default()('form__element toggle-input', this.props.type, {
        'toggle-input--is-active': this.state.isActive,
        'form__element--match-textbox-height': this.props.matchTextboxHeight,
        'form__element--label-offset': this.props.labelOffset
      });

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__FormRowItem__["a" /* default */],
        { shrink: this.props.shrink, grow: this.props.grow, width: this.props.width },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'label',
          { className: classes,
            onBlur: this.handleLabelBlur,
            onFocus: this.handleLabelFocus,
            tabIndex: 0 },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('input', {
            'data-initial-value': this.initialValue,
            defaultChecked: this.getDefaultCheckedProp(),
            checked: this.getCheckedProp(),
            className: 'toggle-input__element',
            name: this.props.type === 'radio' ? this.props.groupID : this.props.id,
            onClick: this.triggerChangeEvent,
            onChange: this.handleInputChange,
            ref: this.setInputRef,
            type: this.props.type,
            value: this.getValueProp()
          }),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: 'toggle-input__indicator' },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { className: 'toggle-input__indicator__icon' },
              this.props.icon
            )
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: 'toggle-input__label' },
            this.props.children
          )
        )
      );
    }
  }]);

  return ToggleInput;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

ToggleInput.propTypes = {
  checked: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  grow: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  shrink: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['checkbox', 'radio']),
  // Is the element controlled or not.
  useProps: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
ToggleInput.defaultProps = {
  onChange: function onChange() {},
  grow: false,
  shrink: false
};


/* harmony default export */ __webpack_exports__["a"] = (ToggleInput);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(5)))

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export dispatchEvent */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dispatchChangeEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDataFromForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return resetFormData; });
var dispatchEvent = function dispatchEvent(eventID, element) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : { bubbles: true, cancelable: true };

  var event = void 0;

  if (typeof Event === 'function') {
    event = new Event(eventID, options);
  } else {
    event = document.createEvent('Event');
    event.initEvent(eventID, options.bubbles, options.cancelable);
  }

  element.dispatchEvent(event);
};

var dispatchChangeEvent = function dispatchChangeEvent(element) {
  dispatchEvent('flood-form-change', element);
};

var getDataFromForm = function getDataFromForm(form) {
  return Array.from(form.elements).reduce(function (formData, element) {
    var name = element.name,
        type = element.type,
        value = element.value;


    if (!name || type === 'button' || type === 'submit' || type === 'reset') {
      return formData;
    };

    if (type === 'checkbox') {
      formData[name] = element.checked;
    } else if (type !== 'radio') {
      formData[name] = value;
    } else if (type === 'radio' && !element.checked && formData[name] === undefined) {
      formData[name] = null;
    } else if (type === 'radio' && element.checked) {
      formData[name] = value;
    }

    return formData;
  }, {});
};

var resetFormData = function resetFormData(form) {
  return Array.from(form.elements).forEach(function (element) {
    // getAttribute is supposedly faster than using the dataset API.
    var defaultValue = element.getAttribute('data-initial-value');

    if (element.type === 'checkbox' || element.type === 'radio') {
      if (defaultValue === 'true') {
        element.checked = true;
      } else {
        element.checked = false;
      }
    } else if (defaultValue !== null) {
      element.value = defaultValue;
    } else {
      element.value = '';
    }
  });
};

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FadeIn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FormElementAddon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FormRowItem__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__icons_LoadingRing__ = __webpack_require__(14);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var Button = function (_Component) {
  _inherits(Button, _Component);

  function Button() {
    _classCallCheck(this, Button);

    return _possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).apply(this, arguments));
  }

  _createClass(Button, [{
    key: 'doesButtonContainIcon',
    value: function doesButtonContainIcon() {
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.toArray(this.props.children).some(function (child) {
        return child.type === __WEBPACK_IMPORTED_MODULE_4__FormElementAddon__["a" /* default */];
      });
    }
  }, {
    key: 'getButtonContent',
    value: function getButtonContent() {
      var _this2 = this;

      var buttonContent = __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.toArray(this.props.children).reduce(function (accumulator, child, childIndex) {
        if (child.type === __WEBPACK_IMPORTED_MODULE_4__FormElementAddon__["a" /* default */]) {
          accumulator.addonNodes.push(__WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(child, {
            addonPlacement: _this2.props.addonPlacement,
            key: childIndex
          }));
        } else {
          accumulator.childNodes.push(child);
        }

        return accumulator;
      }, {
        addonNodes: [],
        childNodes: []
      });

      return {
        childNode: __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: 'button__content', key: 'button-content' },
          buttonContent.childNodes
        ),
        addonNodes: buttonContent.addonNodes
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames;

      var classes = __WEBPACK_IMPORTED_MODULE_0_classnames___default()('button form__element', this.props.additionalClassNames, (_classnames = {
        'form__element--label-offset': this.props.labelOffset,
        'form__element--has-addon': this.props.addonPlacement
      }, _defineProperty(_classnames, 'form__element--has-addon--placed-' + this.props.addonPlacement, this.props.addonPlacement), _defineProperty(_classnames, 'button--' + this.props.priority, this.props.priority), _defineProperty(_classnames, 'button--is-loading', this.props.isLoading), _defineProperty(_classnames, 'button--is-disabled', this.props.disabled), _classnames));

      var _getButtonContent = this.getButtonContent(),
          addonNodes = _getButtonContent.addonNodes,
          childNode = _getButtonContent.childNode;

      var content = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: 'form__element__wrapper' },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'button',
          {
            className: classes,
            disabled: this.props.disabled,
            onClick: this.props.onClick,
            ref: this.props.buttonRef,
            type: this.props.type },
          childNode,
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3__FadeIn__["a" /* default */],
            { 'in': this.props.isLoading },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__icons_LoadingRing__["a" /* default */], null)
          )
        ),
        addonNodes
      );

      if (this.props.wrap) {
        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          this.props.wrapper,
          Object.assign({
            shrink: this.props.shrink,
            grow: this.props.grow
          }, this.props.wrapperProps),
          content
        );
      }

      return content;
    }
  }]);

  return Button;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

Button.propTypes = {
  addonPlacement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['before', 'after']),
  grow: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  priority: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['primary', 'secondary', 'tertiary', 'quaternary']),
  shrink: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['submit', 'reset', 'button'])
};
Button.defaultProps = {
  additionalClassNames: '',
  disabled: false,
  grow: false,
  labelOffset: false,
  priority: 'primary',
  shrink: false,
  type: 'button',
  wrap: true,
  wrapper: __WEBPACK_IMPORTED_MODULE_5__FormRowItem__["a" /* default */],
  wrapperProps: { width: 'auto' }
};
/* harmony default export */ __webpack_exports__["a"] = (Button);

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Overlay__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TransitionGroup__ = __webpack_require__(12);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var minPreferableBottomSpace = 150;
var minPreferableHorizontalSpace = 200;

var ContextMenu = function (_React$PureComponent) {
  _inherits(ContextMenu, _React$PureComponent);

  function ContextMenu() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ContextMenu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ContextMenu.__proto__ || Object.getPrototypeOf(ContextMenu)).call.apply(_ref, [this].concat(args))), _this), _this.handleOverlayClick = function () {
      if (_this.props.onOverlayClick) {
        _this.props.onOverlayClick();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ContextMenu, [{
    key: 'render',
    value: function render() {
      var dropdownStyle = {};
      var shouldRenderAbove = false;

      if (this.props.triggerRef) {
        var buttonBoundingRect = this.props.triggerRef.getBoundingClientRect();
        var windowHeight = global.innerHeight;
        var spaceAbove = buttonBoundingRect.top;
        var spaceBelow = windowHeight - buttonBoundingRect.bottom;

        shouldRenderAbove = spaceBelow < minPreferableBottomSpace && spaceAbove > spaceBelow;

        if (shouldRenderAbove) {
          dropdownStyle.top = 'auto';
          dropdownStyle.bottom = spaceBelow + buttonBoundingRect.height + 5;
          dropdownStyle.maxHeight = buttonBoundingRect.top - 10;
        } else {
          dropdownStyle.top = buttonBoundingRect.bottom + 5;
          dropdownStyle.maxHeight = spaceBelow - 10;
        }

        if (this.props.matchTriggerWidth) {
          dropdownStyle.width = buttonBoundingRect.width;
          dropdownStyle.left = buttonBoundingRect.left;
          dropdownStyle.right = global.innerWidth - buttonBoundingRect.left - buttonBoundingRect.width;
        } else if (this.props.menuAlign === 'right') {
          dropdownStyle.right = global.innerWidth - buttonBoundingRect.left - buttonBoundingRect.width;
        } else {
          dropdownStyle.left = buttonBoundingRect.left;
        }

        this.dropdownStyle = dropdownStyle;
      } else if (this.props.triggerCoordinates) {
        var _windowHeight = global.innerHeight;
        var windowWidth = global.innerWidth;
        var _spaceAbove = this.props.triggerCoordinates.y;
        var _spaceBelow = _windowHeight - _spaceAbove;

        shouldRenderAbove = _spaceBelow < minPreferableBottomSpace && _spaceAbove > _spaceBelow;

        if (shouldRenderAbove) {
          dropdownStyle.top = 'auto';
          dropdownStyle.bottom = _spaceBelow;
          dropdownStyle.maxHeight = _spaceAbove - 10;
        } else {
          dropdownStyle.top = _spaceAbove;
          dropdownStyle.maxHeight = _spaceBelow - 10;
        }

        if (this.props.menuAlign === 'right' || windowWidth - this.props.triggerCoordinates.x < minPreferableHorizontalSpace) {
          dropdownStyle.right = windowWidth - this.props.triggerCoordinates.x;
        } else {
          dropdownStyle.left = this.props.triggerCoordinates.x;
        }

        this.dropdownStyle = dropdownStyle;
      }

      var classes = __WEBPACK_IMPORTED_MODULE_0_classnames___default()('context-menu__items', {
        'context-menu__items--is-up': shouldRenderAbove,
        'context-menu__items--is-down': !shouldRenderAbove,
        'context-menu__items--match-trigger-width': this.props.matchTriggerWidth,
        'context-menu__items--no-padding': !this.props.padding,
        'context-menu__items--no-scrolling': !this.props.scrolling
      });

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__TransitionGroup__["a" /* default */],
        { 'in': this.props.in, transitionName: 'context-menu' },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: 'context-menu', onClick: this.props.onClick },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Overlay__["a" /* default */], Object.assign({ additionalClassNames: 'context-menu__overlay', onClick: this.handleOverlayClick, isTransparent: true }, this.props.overlayProps)),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: classes, ref: this.props.setRef, style: dropdownStyle },
            this.props.children
          )
        )
      );
    }
  }]);

  return ContextMenu;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.PureComponent);

ContextMenu.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  in: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  matchTriggerWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  menuAlign: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['left', 'right']),
  overlayProps: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  padding: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  scrolling: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  triggerCoordinates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    x: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    y: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
  })
};
ContextMenu.defaultProps = {
  matchTriggerWidth: true,
  menuAlign: 'left',
  overlayProps: {},
  padding: true,
  scrolling: true
};
/* harmony default export */ __webpack_exports__["a"] = (ContextMenu);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(5)))

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var Overlay = function (_Component) {
  _inherits(Overlay, _Component);

  function Overlay() {
    _classCallCheck(this, Overlay);

    return _possibleConstructorReturn(this, (Overlay.__proto__ || Object.getPrototypeOf(Overlay)).apply(this, arguments));
  }

  _createClass(Overlay, [{
    key: 'render',
    value: function render() {
      var classes = __WEBPACK_IMPORTED_MODULE_0_classnames___default()('overlay', this.props.additionalClassNames, {
        'overlay--no-interaction': !this.props.isInteractive,
        'overlay--transparent': this.props.isTransparent
      });

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: classes, onClickCapture: this.props.onClick },
        this.props.children
      );
    }
  }]);

  return Overlay;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

Overlay.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  isInteractive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  isTransparent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
Overlay.defaultProps = {
  isInteractive: true
};


/* harmony default export */ __webpack_exports__["a"] = (Overlay);

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var Portal = function (_React$Component) {
  _inherits(Portal, _React$Component);

  function Portal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Portal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Portal.__proto__ || Object.getPrototypeOf(Portal)).call.apply(_ref, [this].concat(args))), _this), _this.mountPoint = null, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Portal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.mountPoint = global.document.createElement('div');
      this.mountPoint.classList.add('portal');
      global.document.body.appendChild(this.mountPoint);
      this.renderChildren(this.props);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      __WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.unmountComponentAtNode(this.mountPoint);
      global.document.body.removeChild(this.mountPoint);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.renderChildren(nextProps);
    }
  }, {
    key: 'renderChildren',
    value: function renderChildren(props) {
      __WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.render(props.children, this.mountPoint);
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return Portal;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

Portal.defaultProps = {
  children: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', null)
};
Portal.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (Portal);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(5)))

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_transition_group_CSSTransition__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_transition_group_CSSTransition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_transition_group_CSSTransition__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_transitionTimeouts__ = __webpack_require__(35);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var TransitionGroup = function (_Component) {
  _inherits(TransitionGroup, _Component);

  function TransitionGroup() {
    _classCallCheck(this, TransitionGroup);

    return _possibleConstructorReturn(this, (TransitionGroup.__proto__ || Object.getPrototypeOf(TransitionGroup)).apply(this, arguments));
  }

  _createClass(TransitionGroup, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_transition_group_CSSTransition___default.a, Object.assign({
        classNames: {
          enter: this.props.transitionName + '--enter',
          enterActive: this.props.transitionName + '--enter--active',
          exit: this.props.transitionName + '--exit',
          exitActive: this.props.transitionName + '--exit--active',
          appear: this.props.transitionName + '--appear',
          appearActive: this.props.transitionName + '--appear--active'
        }
      }, __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.omit(this.props, 'transitionName')));
    }
  }]);

  return TransitionGroup;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

TransitionGroup.defaultProps = {
  mountOnEnter: true,
  unmountOnExit: true,
  timeout: __WEBPACK_IMPORTED_MODULE_3__constants_transitionTimeouts__["a" /* default */].xFast
};


/* harmony default export */ __webpack_exports__["a"] = (TransitionGroup);

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var Checkmark = function (_Component) {
  _inherits(Checkmark, _Component);

  function Checkmark() {
    _classCallCheck(this, Checkmark);

    return _possibleConstructorReturn(this, (Checkmark.__proto__ || Object.getPrototypeOf(Checkmark)).apply(this, arguments));
  }

  _createClass(Checkmark, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "svg",
        {
          className: "icon icon--checkmark",
          width: "18",
          height: "18",
          viewBox: "0 0 18 18",
          xmlns: "http://www.w3.org/2000/svg" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          d: "M4.904 8.563a1.25 1.25 0 1 0-1.597 1.924l3.895 3.23a1.25 1.25 0 0 0 1.727-.125l6.777-7.525a1.25 1.25 0 1 0-1.858-1.673l-5.974 6.633-2.97-2.464z",
          fillRule: "nonzero"
        })
      );
    }
  }]);

  return Checkmark;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Checkmark);

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var LoadingRing = function (_Component) {
  _inherits(LoadingRing, _Component);

  function LoadingRing() {
    _classCallCheck(this, LoadingRing);

    return _possibleConstructorReturn(this, (LoadingRing.__proto__ || Object.getPrototypeOf(LoadingRing)).apply(this, arguments));
  }

  _createClass(LoadingRing, [{
    key: 'render',
    value: function render() {
      var classes = __WEBPACK_IMPORTED_MODULE_0_classnames___default()('icon icon--loading icon--loading--ring', {
        'icon--small': this.props.size === 'small'
      });

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: classes },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'icon__element' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'svg',
            {
              width: '18',
              height: '18',
              viewBox: '0 0 18 18',
              xmlns: 'http://www.w3.org/2000/svg' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'g',
              { fill: 'none', fillRule: 'evenodd', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '2' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('circle', { strokeOpacity: '0.2', cx: '9', cy: '9', r: '6' })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'icon__element icon__ring-slice' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'svg',
            {
              width: '18',
              height: '18',
              viewBox: '0 0 18 18',
              xmlns: 'http://www.w3.org/2000/svg' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'g',
              { fill: 'none', fillRule: 'evenodd', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '2' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path', { d: 'M9,3 C7.227,3 5.633,3.769 4.535,4.992' })
            )
          )
        )
      );
    }
  }]);

  return LoadingRing;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

LoadingRing.defaultProps = {
  size: 'small'
};


/* harmony default export */ __webpack_exports__["a"] = (LoadingRing);

/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_15__;

/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_16__;

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Checkbox__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Container__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ContextMenu__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Form__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_FormElementAddon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_FormError__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_FormGroup__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_FormRow__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_FormRowGroup__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_FormRowItem__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__icons_LoadingRing__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Overlay__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Panel__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_PanelContent__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_PanelFooter__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_PanelHeader__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Portal__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Radio__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Select__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_SelectItem__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Textbox__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_ToggleInput__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_TransitionGroup__ = __webpack_require__(12);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Button", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Button__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Checkbox", function() { return __WEBPACK_IMPORTED_MODULE_1__components_Checkbox__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Container", function() { return __WEBPACK_IMPORTED_MODULE_2__components_Container__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ContextMenu", function() { return __WEBPACK_IMPORTED_MODULE_3__components_ContextMenu__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Form", function() { return __WEBPACK_IMPORTED_MODULE_4__components_Form__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FormElementAddon", function() { return __WEBPACK_IMPORTED_MODULE_5__components_FormElementAddon__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FormError", function() { return __WEBPACK_IMPORTED_MODULE_6__components_FormError__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FormGroup", function() { return __WEBPACK_IMPORTED_MODULE_7__components_FormGroup__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FormRow", function() { return __WEBPACK_IMPORTED_MODULE_8__components_FormRow__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FormRowGroup", function() { return __WEBPACK_IMPORTED_MODULE_9__components_FormRowGroup__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FormRowItem", function() { return __WEBPACK_IMPORTED_MODULE_10__components_FormRowItem__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "LoadingRing", function() { return __WEBPACK_IMPORTED_MODULE_11__icons_LoadingRing__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Overlay", function() { return __WEBPACK_IMPORTED_MODULE_12__components_Overlay__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Panel", function() { return __WEBPACK_IMPORTED_MODULE_13__components_Panel__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PanelContent", function() { return __WEBPACK_IMPORTED_MODULE_14__components_PanelContent__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PanelFooter", function() { return __WEBPACK_IMPORTED_MODULE_15__components_PanelFooter__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PanelHeader", function() { return __WEBPACK_IMPORTED_MODULE_16__components_PanelHeader__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Portal", function() { return __WEBPACK_IMPORTED_MODULE_17__components_Portal__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Radio", function() { return __WEBPACK_IMPORTED_MODULE_18__components_Radio__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Select", function() { return __WEBPACK_IMPORTED_MODULE_19__components_Select__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SelectItem", function() { return __WEBPACK_IMPORTED_MODULE_20__components_SelectItem__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Textbox", function() { return __WEBPACK_IMPORTED_MODULE_21__components_Textbox__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ToggleInput", function() { return __WEBPACK_IMPORTED_MODULE_22__components_ToggleInput__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TransitionGroup", function() { return __WEBPACK_IMPORTED_MODULE_23__components_TransitionGroup__["a"]; });


















































/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__icons_Checkmark__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ToggleInput__ = __webpack_require__(6);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var Checkbox = function (_Component) {
  _inherits(Checkbox, _Component);

  function Checkbox() {
    _classCallCheck(this, Checkbox);

    return _possibleConstructorReturn(this, (Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).apply(this, arguments));
  }

  _createClass(Checkbox, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ToggleInput__["a" /* default */], Object.assign({}, this.props, { type: 'checkbox', icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__icons_Checkmark__["a" /* default */], null) }));
    }
  }]);

  return Checkbox;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Checkbox);

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var Container = function (_PureComponent) {
  _inherits(Container, _PureComponent);

  function Container() {
    _classCallCheck(this, Container);

    return _possibleConstructorReturn(this, (Container.__proto__ || Object.getPrototypeOf(Container)).apply(this, arguments));
  }

  _createClass(Container, [{
    key: 'render',
    value: function render() {
      var classes = __WEBPACK_IMPORTED_MODULE_0_classnames___default()('container');

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: classes },
        this.props.children
      );
    }
  }]);

  return Container;
}(__WEBPACK_IMPORTED_MODULE_2_react__["PureComponent"]);

Container.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};
/* harmony default export */ __webpack_exports__["a"] = (Container);

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var ContextMenuItem = function (_PureComponent) {
  _inherits(ContextMenuItem, _PureComponent);

  function ContextMenuItem() {
    _classCallCheck(this, ContextMenuItem);

    return _possibleConstructorReturn(this, (ContextMenuItem.__proto__ || Object.getPrototypeOf(ContextMenuItem)).apply(this, arguments));
  }

  _createClass(ContextMenuItem, [{
    key: 'render',
    value: function render() {
      var classes = __WEBPACK_IMPORTED_MODULE_0_classnames___default()('context-menu__item', this.props.className);

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: classes, onClick: this.props.onClick },
        this.props.children
      );
    }
  }]);

  return ContextMenuItem;
}(__WEBPACK_IMPORTED_MODULE_2_react__["PureComponent"]);

ContextMenuItem.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
/* harmony default export */ __webpack_exports__["a"] = (ContextMenuItem);

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_transition_group_CSSTransition__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_transition_group_CSSTransition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_transition_group_CSSTransition__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var FadeIn = function (_React$PureComponent) {
  _inherits(FadeIn, _React$PureComponent);

  function FadeIn() {
    _classCallCheck(this, FadeIn);

    return _possibleConstructorReturn(this, (FadeIn.__proto__ || Object.getPrototypeOf(FadeIn)).apply(this, arguments));
  }

  _createClass(FadeIn, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react_transition_group_CSSTransition___default.a,
        Object.assign({ classNames: 'fade', mountOnEnter: true, timeout: 375 }, this.props),
        this.props.children
      );
    }
  }]);

  return FadeIn;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.PureComponent);

/* harmony default export */ __webpack_exports__["a"] = (FadeIn);

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_forms__ = __webpack_require__(7);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var Form = function (_Component) {
  _inherits(Form, _Component);

  function Form() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Form);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref, [this].concat(args))), _this), _this.formRef = null, _this.getFormData = function () {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_forms__["b" /* getDataFromForm */])(_this.formRef);
    }, _this.resetForm = function () {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_forms__["c" /* resetFormData */])(_this.formRef);
    }, _this.handleFormChange = function (event) {
      if (_this.props.onChange) {
        var formData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_forms__["b" /* getDataFromForm */])(_this.formRef);
        _this.props.onChange({ event: event, formData: formData });
      }
    }, _this.handleFormSubmit = function (event) {
      event.preventDefault();

      if (_this.props.onSubmit) {
        var formData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_forms__["b" /* getDataFromForm */])(event.target);
        _this.props.onSubmit({ event: event, formData: formData });
      }
    }, _this.setFormRef = function (ref) {
      return _this.formRef = ref;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Form, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.formRef.addEventListener('flood-form-change', this.handleFormChange);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.formRef.removeEventListener('flood-form-change', this.handleFormChange);
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'form',
        {
          className: this.props.className,
          onChange: this.handleFormChange,
          onInput: this.handleFormChange,
          onSubmit: this.handleFormSubmit,
          ref: this.setFormRef },
        this.props.children
      );
    }
  }]);

  return Form;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

Form.propTypes = {
  appendErrors: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node,
  onChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onSubmit: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  prependErrors: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
};


/* harmony default export */ __webpack_exports__["a"] = (Form);

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FormRowItem__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var FormError = function (_PureComponent) {
  _inherits(FormError, _PureComponent);

  function FormError() {
    _classCallCheck(this, FormError);

    return _possibleConstructorReturn(this, (FormError.__proto__ || Object.getPrototypeOf(FormError)).apply(this, arguments));
  }

  _createClass(FormError, [{
    key: 'render',
    value: function render() {
      // Maybe add some classes later.
      var classes = __WEBPACK_IMPORTED_MODULE_0_classnames___default()('form__element error', {
        'error--is-loading': this.props.isLoading
      });

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__FormRowItem__["a" /* default */],
        { className: classes, type: 'error' },
        this.props.children
      );
    }
  }]);

  return FormError;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (FormError);

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FormRowItem__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var FormRowItemGroup = function (_Component) {
  _inherits(FormRowItemGroup, _Component);

  function FormRowItemGroup() {
    _classCallCheck(this, FormRowItemGroup);

    return _possibleConstructorReturn(this, (FormRowItemGroup.__proto__ || Object.getPrototypeOf(FormRowItemGroup)).apply(this, arguments));
  }

  _createClass(FormRowItemGroup, [{
    key: 'getLabel',
    value: function getLabel() {
      if (this.props.label) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'label',
          { className: 'form__element__label' },
          this.props.label
        );
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1__FormRowItem__["a" /* default */],
        { className: 'form__group', width: this.props.width },
        this.getLabel(),
        this.props.children
      );
    }
  }]);

  return FormRowItemGroup;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (FormRowItemGroup);

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var FormRow = function (_Component) {
  _inherits(FormRow, _Component);

  function FormRow() {
    _classCallCheck(this, FormRow);

    return _possibleConstructorReturn(this, (FormRow.__proto__ || Object.getPrototypeOf(FormRow)).apply(this, arguments));
  }

  _createClass(FormRow, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var classes = __WEBPACK_IMPORTED_MODULE_0_classnames___default()('form__row', (_classnames = {
        'form__row--wrap': this.props.wrap
      }, _defineProperty(_classnames, 'form__row--justify--' + this.props.justify, this.props.justify), _defineProperty(_classnames, 'form__row--align--' + this.props.align, this.props.align), _classnames));

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: classes },
        this.props.children
      );
    }
  }]);

  return FormRow;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

FormRow.propTypes = {
  align: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['start', 'center', 'end']),
  justify: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['start', 'center', 'end']),
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  wrap: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};


/* harmony default export */ __webpack_exports__["a"] = (FormRow);

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var FormRowGroup = function (_PureComponent) {
  _inherits(FormRowGroup, _PureComponent);

  function FormRowGroup() {
    _classCallCheck(this, FormRowGroup);

    return _possibleConstructorReturn(this, (FormRowGroup.__proto__ || Object.getPrototypeOf(FormRowGroup)).apply(this, arguments));
  }

  _createClass(FormRowGroup, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "form__row form__row--group" },
        this.props.children
      );
    }
  }]);

  return FormRowGroup;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (FormRowGroup);

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var Panel = function (_PureComponent) {
  _inherits(Panel, _PureComponent);

  function Panel() {
    _classCallCheck(this, Panel);

    return _possibleConstructorReturn(this, (Panel.__proto__ || Object.getPrototypeOf(Panel)).apply(this, arguments));
  }

  _createClass(Panel, [{
    key: 'render',
    value: function render() {
      var classes = __WEBPACK_IMPORTED_MODULE_0_classnames___default()('panel panel--' + this.props.theme, 'panel--' + this.props.spacing, {
        'panel--transparent': this.props.transparent
      });

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: classes },
        this.props.children
      );
    }
  }]);

  return Panel;
}(__WEBPACK_IMPORTED_MODULE_2_react__["PureComponent"]);

Panel.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  theme: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['light', 'dark']),
  spacing: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['small', 'medium', 'large']),
  transparent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
Panel.defaultProps = {
  spacing: 'medium',
  theme: 'light'
};


/* harmony default export */ __webpack_exports__["a"] = (Panel);

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var PanelContent = function (_PureComponent) {
  _inherits(PanelContent, _PureComponent);

  function PanelContent() {
    _classCallCheck(this, PanelContent);

    return _possibleConstructorReturn(this, (PanelContent.__proto__ || Object.getPrototypeOf(PanelContent)).apply(this, arguments));
  }

  _createClass(PanelContent, [{
    key: 'render',
    value: function render() {
      var classes = __WEBPACK_IMPORTED_MODULE_0_classnames___default()('panel__content', _defineProperty({}, 'panel__content--has-border--' + this.props.borderPosition, this.props.hasBorder));

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: classes },
        this.props.children
      );
    }
  }]);

  return PanelContent;
}(__WEBPACK_IMPORTED_MODULE_2_react__["PureComponent"]);

PanelContent.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  hasBorder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  borderPosition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
PanelContent.defaultProps = {
  hasBorder: false,
  borderPosition: 'top'
};
/* harmony default export */ __webpack_exports__["a"] = (PanelContent);

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var PanelFooter = function (_PureComponent) {
  _inherits(PanelFooter, _PureComponent);

  function PanelFooter() {
    _classCallCheck(this, PanelFooter);

    return _possibleConstructorReturn(this, (PanelFooter.__proto__ || Object.getPrototypeOf(PanelFooter)).apply(this, arguments));
  }

  _createClass(PanelFooter, [{
    key: 'render',
    value: function render() {
      var classes = __WEBPACK_IMPORTED_MODULE_0_classnames___default()('panel__footer', {
        'panel__footer--has-border': this.props.hasBorder
      });

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: classes },
        this.props.children
      );
    }
  }]);

  return PanelFooter;
}(__WEBPACK_IMPORTED_MODULE_2_react__["PureComponent"]);

PanelFooter.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  hasBorder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
/* harmony default export */ __webpack_exports__["a"] = (PanelFooter);

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var PanelHeader = function (_PureComponent) {
  _inherits(PanelHeader, _PureComponent);

  function PanelHeader() {
    _classCallCheck(this, PanelHeader);

    return _possibleConstructorReturn(this, (PanelHeader.__proto__ || Object.getPrototypeOf(PanelHeader)).apply(this, arguments));
  }

  _createClass(PanelHeader, [{
    key: 'render',
    value: function render() {
      var classes = __WEBPACK_IMPORTED_MODULE_0_classnames___default()('panel__header panel__header--level-' + this.props.level, {
        'panel__header--has-border': this.props.hasBorder
      });

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: classes },
        this.props.children
      );
    }
  }]);

  return PanelHeader;
}(__WEBPACK_IMPORTED_MODULE_2_react__["PureComponent"]);

PanelHeader.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  hasBorder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  level: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf([1, 2, 3, 4, 5, 6])
};
PanelHeader.defaultProps = {
  hasBorder: false,
  level: 1
};
/* harmony default export */ __webpack_exports__["a"] = (PanelHeader);

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__icons_Circle__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ToggleInput__ = __webpack_require__(6);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var Radio = function (_Component) {
  _inherits(Radio, _Component);

  function Radio() {
    _classCallCheck(this, Radio);

    return _possibleConstructorReturn(this, (Radio.__proto__ || Object.getPrototypeOf(Radio)).apply(this, arguments));
  }

  _createClass(Radio, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ToggleInput__["a" /* default */], Object.assign({}, this.props, {
        icon: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__icons_Circle__["a" /* default */], null),
        id: this.props.groupID,
        type: 'radio',
        value: this.props.id
      }));
    }
  }]);

  return Radio;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

Radio.propTypes = {
  groupID: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  id: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number]).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Radio);

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ContextMenu__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_forms__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FormElementAddon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__icons_Chevron__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__FormRowItem__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Portal__ = __webpack_require__(11);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var Select = function (_Component) {
  _inherits(Select, _Component);

  function Select(props) {
    _classCallCheck(this, Select);

    var _this = _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));

    _this.menuRef = null;
    _this.inputRef = null;
    _this.triggerRef = null;

    _this.handleTriggerClick = function () {
      if (!_this.props.disabled) {
        _this.toggleOpenState();
      }
    };

    _this.handleItemClick = function (id) {
      _this.setState({ isOpen: false, selectedID: id }, function () {
        if (_this.props.onSelect) {
          _this.props.onSelect(id);
        }

        if (_this.inputRef) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_forms__["a" /* dispatchChangeEvent */])(_this.inputRef);
        }
      });
    };

    _this.handleKeyDown = function (event) {
      if (event.key === 'Escape') {
        event.preventDefault();

        _this.setState({ isOpen: false });
      }
    };

    _this.handleOverlayClick = function () {
      _this.toggleOpenState();
    };

    _this.handleWindowScroll = function (event) {
      if (_this.menuRef && !_this.menuRef.contains(event.target)) {
        if (_this.state.isOpen) {
          _this.setState({ isOpen: false });
        }
      }
    };

    _this.setInputRef = function (ref) {
      return _this.inputRef = ref;
    };

    _this.setMenuRef = function (ref) {
      return _this.menuRef = ref;
    };

    _this.setTriggerRef = function (ref) {
      if (_this.state.triggerRef !== ref) {
        _this.setState({ triggerRef: ref });
      }
    };

    _this.toggleOpenState = function () {
      _this.setState({
        isOpen: !_this.state.isOpen
      });
    };

    _this.state = {
      isOpen: false,
      selectedID: _this.getInitialSelectedID(props)
    };
    return _this;
  }

  _createClass(Select, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(_prevProps, prevState) {
      if (!prevState.isOpen && this.state.isOpen) {
        // TODO: Set focus on the dropdown menu.
      } else if (prevState.isOpen && !this.state.isOpen) {
        // this.triggerRef.focus();
      }
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(_nextProps, nextState) {
      if (nextState.isOpen && !this.state.isOpen) {
        global.addEventListener('keydown', this.handleKeyDown);
        global.addEventListener('scroll', this.handleWindowScroll, { capture: true });

        if (this.props.onOpen) {
          this.props.onOpen();
        }
      } else if (!nextState.isOpen && this.state.isOpen) {
        global.addEventListener('keydown', this.handleKeyDown);
        global.removeEventListener('scroll', this.handleWindowScroll, { capture: true });

        if (this.props.onClose) {
          this.props.onClose();
        }
      }
    }
  }, {
    key: 'getInitialSelectedID',
    value: function getInitialSelectedID(props) {
      return props.defaultID || props.children.find(function (child) {
        return child.id != null;
      }) || '';
    }
  }, {
    key: 'getItemList',
    value: function getItemList(children) {
      var _this2 = this;

      return children.reduce(function (accumulator, child) {
        if (child.props.placeholder) {
          return accumulator;
        }

        accumulator.push(__WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(child, {
          onClick: _this2.handleItemClick,
          isSelected: child.props.id === _this2.state.selectedID
        }));

        return accumulator;
      }, []);
    }
  }, {
    key: 'getLabel',
    value: function getLabel() {
      if (this.props.label) {
        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'label',
          { className: 'form__element__label', htmlFor: this.props.id },
          this.props.label
        );
      }
    }
  }, {
    key: 'getSelectedItem',
    value: function getSelectedItem(children) {
      var _this3 = this;

      var selectedItem = children.find(function (child, index) {
        return _this3.props.persistentPlaceholder && child.props.placeholder || !_this3.state.selectedID && index === 0 || child.props.id === _this3.state.selectedID;
      });

      if (selectedItem) {
        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(selectedItem, { isTrigger: true });
      }
    }
  }, {
    key: 'getTrigger',
    value: function getTrigger(selectItems) {
      var selectedItem = this.getSelectedItem(selectItems);

      if (this.props.triggerComponent) {
        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          this.props.triggerComponent,
          {
            isOpen: this.state.isOpen,
            onClick: this.handleTriggerClick,
            setRef: this.setTriggerRef
          },
          selectedItem
        );
      }

      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__Button__["a" /* default */],
        {
          additionalClassNames: 'select__button',
          buttonRef: this.setTriggerRef,
          addonPlacement: 'after',
          onClick: this.handleTriggerClick,
          priority: this.props.priority,
          wrap: false },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__FormElementAddon__["a" /* default */],
          { className: 'select__indicator' },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__icons_Chevron__["a" /* default */], null)
        ),
        selectedItem
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var selectItems = __WEBPACK_IMPORTED_MODULE_3_react___default.a.Children.toArray(this.props.children);
      var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('select form__element', this.props.additionalClassNames, {
        'form__element--disabled': this.props.disabled,
        'form__element--label-offset': this.props.labelOffset,
        'select--is-open': this.state.isOpen
      });

      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__FormRowItem__["a" /* default */],
        {
          shrink: this.props.shrink,
          grow: this.props.grow,
          labelOffset: this.props.labelOffset,
          width: this.props.width
        },
        this.getLabel(),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'div',
          { className: classes },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('input', {
            className: 'input input--hidden',
            name: this.props.id,
            onChange: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.noop,
            tabIndex: -1,
            ref: this.setInputRef,
            type: 'text',
            value: this.state.selectedID }),
          this.getTrigger(selectItems),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10__Portal__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5__ContextMenu__["a" /* default */],
              {
                onOverlayClick: this.handleOverlayClick,
                'in': this.state.isOpen,
                matchTriggerWidth: this.props.matchTriggerWidth,
                menuAlign: this.props.menuAlign,
                setRef: this.setMenuRef,
                triggerRef: this.state.triggerRef
              },
              this.getItemList(selectItems)
            )
          )
        )
      );
    }
  }]);

  return Select;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

Select.propTypes = {
  defaultID: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),
  value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,
  id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]).isRequired,
  onClose: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  onOpen: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  onSelect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};
Select.defaultProps = {
  defaultID: '',
  persistentPlaceholder: false,
  priority: 'quaternary'
};
/* harmony default export */ __webpack_exports__["a"] = (Select);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(5)))

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__icons_Checkmark__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ContextMenuItem__ = __webpack_require__(20);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var SelectItem = function (_Component) {
  _inherits(SelectItem, _Component);

  function SelectItem() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SelectItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SelectItem.__proto__ || Object.getPrototypeOf(SelectItem)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (!_this.props.onClick) {
        return;
      }

      _this.props.onClick(_this.props.id);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SelectItem, [{
    key: 'render',
    value: function render() {
      var icon = null;

      if (!this.props.isTrigger && this.props.isSelected) {
        icon = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__icons_Checkmark__["a" /* default */], null);
      }

      var classes = __WEBPACK_IMPORTED_MODULE_0_classnames___default()({
        'select__item context-menu__item': !this.props.isTrigger,
        'select__item--is-selected': this.props.isSelected
      });

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__ContextMenuItem__["a" /* default */],
        { className: classes, onClick: this.handleClick },
        icon,
        this.props.children
      );
    }
  }]);

  return SelectItem;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

SelectItem.propTypes = {
  isSelected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  isTrigger: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};
SelectItem.defaultProps = {
  isTrigger: false
};
/* harmony default export */ __webpack_exports__["a"] = (SelectItem);

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FormElementAddon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FormRowItem__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var Textbox = function (_Component) {
  _inherits(Textbox, _Component);

  function Textbox() {
    _classCallCheck(this, Textbox);

    return _possibleConstructorReturn(this, (Textbox.__proto__ || Object.getPrototypeOf(Textbox)).apply(this, arguments));
  }

  _createClass(Textbox, [{
    key: 'getLabel',
    value: function getLabel() {
      if (this.props.label) {
        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'label',
          { className: 'form__element__label', htmlFor: this.props.id },
          this.props.label
        );
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this,
          _classnames;

      var addonCount = 0;
      var children = __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.map(this.props.children, function (child, index) {
        if (child && child.type === __WEBPACK_IMPORTED_MODULE_3__FormElementAddon__["a" /* default */]) {
          addonCount++;
          return __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(child, {
            addonIndex: addonCount,
            addonPlacement: _this2.props.addonPlacement
          });
        }

        return child;
      });

      var inputClasses = __WEBPACK_IMPORTED_MODULE_0_classnames___default()('input input--text form__element', (_classnames = {}, _defineProperty(_classnames, 'form__element--has-addon--placed-' + this.props.addonPlacement, this.props.addonPlacement && this.props.children), _defineProperty(_classnames, 'form__element--has-addon--count-' + addonCount, addonCount > 0), _defineProperty(_classnames, 'form__element--label-offset', this.props.labelOffset), _classnames));
      var wrapperClasses = __WEBPACK_IMPORTED_MODULE_0_classnames___default()('form__element__wrapper', this.props.wrapperClassName);

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__FormRowItem__["a" /* default */],
        { width: this.props.width },
        this.getLabel(),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: wrapperClasses },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('input', {
            className: inputClasses,
            defaultValue: this.props.defaultValue,
            placeholder: this.props.placeholder,
            name: this.props.id,
            onChange: this.props.onChange,
            onClick: this.props.onClick,
            ref: this.props.setRef,
            tabIndex: 0,
            type: this.props.type
          }),
          children
        )
      );
    }
  }]);

  return Textbox;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

Textbox.propTypes = {
  defaultValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  addonPlacement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['before', 'after']),
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired,
  setRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['password', 'text'])
};
Textbox.defaultProps = {
  type: 'text'
};
/* harmony default export */ __webpack_exports__["a"] = (Textbox);

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Transition timeout parity with Sass variables.

/* harmony default export */ __webpack_exports__["a"] = ({
  xxSlow: 7 / 8 * 1000,
  xSlow: 3 / 4 * 1000,
  slow: 5 / 8 * 1000,
  medium: 1 / 2 * 1000,
  fast: 3 / 8 * 1000,
  xFast: 1 / 4 * 1000,
  xxFast: 1 / 8 * 1000
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var Chevron = function (_Component) {
  _inherits(Chevron, _Component);

  function Chevron() {
    _classCallCheck(this, Chevron);

    return _possibleConstructorReturn(this, (Chevron.__proto__ || Object.getPrototypeOf(Chevron)).apply(this, arguments));
  }

  _createClass(Chevron, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "svg",
        {
          className: "icon icon--chevron",
          width: "18",
          height: "18",
          viewBox: "0 0 18 18",
          xmlns: "http://www.w3.org/2000/svg" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          d: "M5.193 6.631A1 1 0 0 0 3.733 8l5.199 5.549 5.376-5.536a1 1 0 0 0-1.435-1.394L8.958 10.65 5.193 6.631z",
          fillRule: "nonzero" })
      );
    }
  }]);

  return Chevron;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Chevron);

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var Checkmark = function (_Component) {
  _inherits(Checkmark, _Component);

  function Checkmark() {
    _classCallCheck(this, Checkmark);

    return _possibleConstructorReturn(this, (Checkmark.__proto__ || Object.getPrototypeOf(Checkmark)).apply(this, arguments));
  }

  _createClass(Checkmark, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "svg",
        {
          className: "icon icon--checkmark",
          width: "18",
          height: "18",
          viewBox: "0 0 18 18",
          xmlns: "http://www.w3.org/2000/svg" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", { cx: "9", cy: "9", r: "4" })
      );
    }
  }]);

  return Checkmark;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Checkmark);

/***/ }),
/* 38 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_38__;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(17);


/***/ })
/******/ ]);
});
//# sourceMappingURL=main.js.map